import { render, staticRenderFns } from "./indexComponent.vue?vue&type=template&id=23f4bd7e&"
import script from "./indexComponent.vue?vue&type=script&lang=js&"
export * from "./indexComponent.vue?vue&type=script&lang=js&"
import style0 from "./indexComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports